import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((c) => {
  const p = sessionStorage.getItem("previewAs");
  if (p) c.headers["X-Preview-As"] = JSON.parse(p).id;
  const t = sessionStorage.getItem("tk");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !String(cfg.url).includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        const { data } = await refreshing;
        refreshing = null;
        if (data.access_token) sessionStorage.setItem("tk", data.access_token);
        return api(cfg);
      } catch (e) {
        refreshing = null;
        sessionStorage.removeItem("tk");
        if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || d.message || String(d);
}

export async function download(path, { method = "get", body, filename }) {
  const r = await api.request({ url: path, method, data: body, responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const fmtDate = (d) => (d ? String(d).slice(0, 10) : "—");
export const fmtUS = (d) => {
  if (!d) return "—";
  const s = String(d).slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(s) ? `${s.slice(5, 7)}/${s.slice(8, 10)}/${s.slice(0, 4)}` : s;
};
const ET_TZ = "America/New_York";
export const fmtTime = (hm) => {
  if (!hm) return "—";
  const [h, m] = String(hm).slice(0, 5).split(":").map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return hm;
  return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};
export const fmtDT = (iso) => (iso ? new Date(iso).toLocaleString("en-US", { timeZone: ET_TZ, month: "2-digit", day: "2-digit", year: "numeric", hour: "numeric", minute: "2-digit" }).replace(",", "") : "—");
export const fmtAny = (d) => {
  if (!d) return "—";
  const s = String(d);
  if (s.length <= 10) return fmtUS(s);
  return /(Z|[+-]\d{2}:\d{2})$/.test(s) ? fmtDT(s) : `${fmtUS(s)} ${fmtTime(s.slice(11, 16))}`;
};
export const fmtET = (iso) => (iso ? `${fmtDT(iso)} ET` : "—");
export const STATUS_LABEL = { ACTIVE: "Active", DISCHARGED: "Discharged", "RE-ENGAGE": "Re-Engage" };
export const statusLabel = (s) => STATUS_LABEL[s] || (s ? s.charAt(0) + s.slice(1).toLowerCase() : "—");
export const today = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/New_York" });
